import { ADD_NOTIFICATION, ADD_ERROR_NOTIFICATION, REMOVE_NOTIFICATION } from './action-types'
import { SET_NOTIFICATION, SET_ERROR_NOTIFICATION, REMOVE_NOTIFICATION_MUTATION } from './mutation-types'

import { getDecoratedErrorMessage } from '@/utils/errors'


let notificationTimeouts = new Map()

export default {
	[ADD_NOTIFICATION] ({ commit }, notification) {
		// Handle both string and object inputs
		const notificationData = typeof notification === 'string'
			? { message: notification, type: 'info' }
			: notification

		const notificationWithId = {
			...notificationData,
			id: Date.now() + Math.random()
		}

		commit(SET_NOTIFICATION, notificationWithId)

		// Handle timeout in action
		const timeoutId = setTimeout(() => {
			commit(REMOVE_NOTIFICATION_MUTATION, notificationWithId.id)
			notificationTimeouts.delete(notificationWithId.id)
		}, 4000)

		notificationTimeouts.set(notificationWithId.id, timeoutId)
	},

	[ADD_ERROR_NOTIFICATION] ({ commit }, error) {
		const notificationWithId = {
			message: getDecoratedErrorMessage(error),
			type: 'error',
			id: Date.now() + Math.random()
		}

		commit(SET_ERROR_NOTIFICATION, notificationWithId)

		const timeoutId = setTimeout(() => {
			commit(REMOVE_NOTIFICATION_MUTATION, notificationWithId.id)
			notificationTimeouts.delete(notificationWithId.id)
		}, 4000)

		notificationTimeouts.set(notificationWithId.id, timeoutId)
	},

	[REMOVE_NOTIFICATION] ({ commit }, notificationId) {
		if (notificationTimeouts.has(notificationId)) {
			clearTimeout(notificationTimeouts.get(notificationId))
			notificationTimeouts.delete(notificationId)
		}
		commit(REMOVE_NOTIFICATION_MUTATION, notificationId)
	}
}
